<template>
  <el-card class="app-table-container" :body-style="{ padding: '20px' }">
    <div slot="header">
      <div class="global-table-header">
        <div></div>
        <!-- <list-search ref="listSearch" @listSearchEvn="listSearchEvn" /> -->
        <button
          class="global-button-style"
          @click="(title = '新建'), (centerDialogVisible = true)"
        >
          新建
        </button>
      </div>
    </div>
    <div class="global-body-wrap">
      <AppTable
        :tableProps="tableProps"
        :tableData="tableData"
        :currentPage="params.page"
        :pageSize="params.limit"
        :showHeader="false"
        @tableHandle="tableHandle"
        @switchChange="switchChange"
      />
    </div>
    <Pagination
      :pageSize="params.limit"
      :total="total"
      @pageNum="pageNum"
    />
    <el-dialog
      :title="title"
      :visible.sync="centerDialogVisible"
      width="500px"
      center
      @close="initForm"
    >
      <div>
        <el-form :model="form" ref="form" label-width="80px">
          <el-form-item label="标题">
            <el-input v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="开始时间">
            <el-date-picker
              v-model="form.start"
              type="datetime"
              :picker-options="startDateDisabled"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker
              v-model="form.end"
              type="datetime"
              :picker-options="startDateDisabled"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="重复">
            <el-select v-model="form.repeat">
              <el-option label="一次性" value="0"> </el-option>
              <el-option label="每天" value="1-7"> </el-option>
              <el-option label="周一至周五" value="1-5"> </el-option>
              <el-option label="周一至周六" value="1-6"> </el-option>
              <el-option label="周六日" value="6-7"> </el-option>
              <el-option label="周日" value="7"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="中文">
            <el-input
              type="textarea"
              :rows="4"
              v-model="form.content.zh"
            ></el-input>
          </el-form-item>
          <el-form-item label="英文">
            <el-input
              type="textarea"
              :rows="4"
              v-model="form.content.en"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="createMsg">确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import AppTable from "@/components/appTable";
import Pagination from "@/components/pagination";
import ListSearch from "@/components/listSearch";

export default {
  components: {
    AppTable,
    ListSearch,
    Pagination
  },
  computed: {
    tableProps() {
      let tableProps = [
        {
          prop: "title"
        },
        {
          prop: "timeRange"
        },
        {
          prop: "repeat"
        },
        {
          prop: "handle",
          width: 200,
          btn: ["swithBtn", this.$t("commonMsg.edit"), this.$t("commonMsg.del")]
        }
      ];
      return tableProps;
    }
  },
  data() {
    return {
      tableData: [],
      total: 0,
      params: { limit: 20, page: 1, type: 1 },
      centerDialogVisible: false,
      startDateDisabled: {
        disabledDate(time) {
          return time.getTime() + 24 * 3600 * 1000 < Date.now();
        }
      },
      itemID: "",
      title: "新建",
      form: {
        title: "",
        start: "",
        end: "",
        repeat: "1-5",
        content: {
          zh: "",
          en: ""
        },
        status: 0,
        type: 1
      }
    };
  },
  methods: {
    getBotMsg() {
      this.$http.getBotMsg(this.params).then(res => {
        this.tableData = res.data.results;
        this.total = res.data.count
      });
    },
    createMsg() {
      if (this.title === "新建") {
        this.$http.createBotMsg(this.form).then(res => {
          this.getBotMsg();
          this.centerDialogVisible = false;
          this.elMsg("创建成功", "success");
        });
      } else {
        this.$http.updateBotMsg(this.itemID, this.form).then(res => {
          this.getBotMsg();
          this.centerDialogVisible = false;
          this.elMsg("编辑成功", "success");
        });
      }
    },
    initForm() {
      for (let i in this.form) {
        if (i === "status" || i === "type") continue;
        if (i === "content") {
          this.form[i].zh = "";
          this.form[i].en = "";
        } else if (i === "repeat") {
          this.form[i] = "1-5";
        } else {
          this.form[i] = "";
        }
      }
    },
    switchChange({ data }) {
      let params = data.row;
      this.$http.updateBotMsg(params._id, params);
    },
    delBotMsg(params) {
      this.$http.delBotMsg(params._id).then(res => {
        this.getBotMsg();
        this.elMsg("删除成功", "success");
      });
    },
    tableHandle({ type, data }) {
      if (type === this.$t("commonMsg.del")) {
        this.delBotMsg(data.row);
      } else if (type === this.$t("commonMsg.edit")) {
        this.itemID = data.row._id;
        this.form.title = data.row.title;
        this.form.start = data.row.start;
        this.form.end = data.row.end;
        this.form.repeat = data.row.repeat;
        this.form.content.zh = data.row.content.zh;
        this.form.content.en = data.row.content.en;
        this.form.status = data.row.status;
        this.title = "编辑";
        this.centerDialogVisible = true;
      }
    },
    listSearchEvn() {},
    pageNum(page) {
      this.params.page = page;
      this.getBotMsg();
    }
  },
  mounted() {
    this.getBotMsg();
  }
};
</script>
